import { pumaAPI } from "./api"
import { IShortcut } from "../models"
import {
    PumaPaginatedResponse,
    PumaParsedPaginatedResponse,
} from "./models/api/puma"
import { ShortcutDTO } from "./models/dto/shortcut"

export const getShortcuts = (
    workspaceId: number | null,
    filter?: string,
): Promise<PumaParsedPaginatedResponse<IShortcut>> =>
    pumaAPI
        .getJSON("shortcuts", { filter, workspaceId })
        .then((shortcuts: PumaPaginatedResponse<ShortcutDTO>) => ({
            paging: {
                pageSize: shortcuts.Paging.PageSize,
                totalRecordCount: shortcuts.Paging.TotalRecordCount,
            },
            data: shortcuts.Data.$values.map((shortcut: ShortcutDTO) => ({
                id: shortcut.Id,
                url: shortcut.Url,
                title: shortcut.Title,
                workspaceId: shortcut.WorkspaceId,
                workspaceLabel: shortcut.WorkspaceScreenLabel,
                linkData:
                    !!shortcut.Url || !shortcut.Data
                        ? undefined
                        : {
                              itemId: shortcut.Data.ItemId,
                              parentId: shortcut.Data.ParentId,
                              conceptId: shortcut.Data.ListId,
                              collectionId: shortcut.Data.SelectionId,
                              workspaceId: shortcut.Data.WorkspaceId,
                              attachmentId: shortcut.Data.AttachmentId,
                              scriptId: shortcut.Data.ScriptId,
                              listScriptId: shortcut.Data.ListScriptId,
                              hasParameters: shortcut.Data.HasParameters,
                          },
            })),
        }))
